import { apiClient } from "../../../../lib/api-client";
import { useMutation } from '@tanstack/react-query';
import { ChangePasswordRequest } from "../types/ChangePasswordRequest";
import { ChangePasswordResult } from "../types/ChangePasswordResult";

export const useChangePasswordMutation = () => useMutation({
	mutationFn: async (request: ChangePasswordRequest) => {
		try {
			let data: ChangePasswordResult = await apiClient.post("my-account/change-password", {
				newPassword: request.newPassword,
				oldPassword: request.oldPassword
			});

			return {
				isOk: data.isSuccess,
				message: data.errorMessage
			};
		} catch {
			return {
				isOk: false,
				message: "Failed to change password"
			};
		}
	}
});